import WrapperFormulaNode from "./WrapperFormulaNode.js";

/**
 * `orFormulaNode` is a concrete implementation
 * of `wrapperFormulaNode` representing a server side
 * `or` statement used to compute a keyFigure value.
 *
 * If the keyFigure is `null` then a default value is used instead.
 *
 * @param {number} spec.fallBackValue - default value
 */

/**
 * TODO: write documentation
 */
export default class OrFormulaNode extends WrapperFormulaNode {
	constructor({ fallBackValue } = {}) {
		super(...arguments);
		this._fallBackValue = fallBackValue;
	}

	getFallBackValue() {
		return this._fallBackValue;
	}

	accept(visitor, additionalInformation) {
		return visitor.visitOrNode(this, additionalInformation);
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.fallBackValue = this._fallBackValue;

		return properties;
	}

	static getType() {
		return "OrValueNode";
	}

	static precedence() {
		return 3;
	}
}
